// extracted by mini-css-extract-plugin
export default {"select":"_166Q","placeholderVisible":"_3A4c"};